import { useSelector } from "react-redux";
import { encryptData } from "../../../utilites/encryption";

const V2_APP_URL = process.env.REACT_APP_V2_BASEURL || "https://app.v2.unclekam.com";

export default function UpgradeToV2Banner() {
  const user = useSelector((state) => state.user);

  if (!user?.LoginData) return null;

  const handleTakeMeThere = () => {
    const data = {
      token: localStorage.getItem("token"),
      callback_url: window.location.href,
    };
    const encryptedData = encryptData(data);
    const encodedData = encodeURIComponent(encryptedData);
    const timestamp = Date.now();
    const url= `${V2_APP_URL}/sso?data=${encodedData}&_nocache=${timestamp}`;
    console.log("@url",url);
    window.open(url, "_blank", "noreferrer");
  };

  return (
    <div className="upgrade-to-v2-banner d-flex align-items-center justify-content-center flex-wrap">
      <span className="upgrade-to-v2-banner-icon">✨</span>
      <span className="upgrade-to-v2-banner-text">
        A brand new UnclekamTax experience is here
      </span>
      <button
        type="button"
        onClick={handleTakeMeThere}
        className="upgrade-to-v2-banner-btn"
      >
        Take me there <span aria-hidden="true">→</span>
      </button>
    </div>
  );
}
